import { Button, Link, Stack, Typography } from '@mui/material';

import LockIcon from '@/components/Icons/LockIcon';
import { Levels } from '@/graphql';
import useIsTrainingEnabled from '@/hooks/useIsTrainingEnabled';
import useOrg from '@/hooks/useOrg';
import { links } from '@/localization';

import { TrainingAnimationContainer } from '../../Overview/styled';
import EmptyStateContainer from '../../sections/EmptyStateContainer';

function EmptyState() {
  const isTrainingEnabled = useIsTrainingEnabled();
  const org = useOrg();

  return (
    <EmptyStateContainer>
      <Stack alignItems="center" maxWidth={500} gap={4}>
        <TrainingAnimationContainer />
        <Stack gap={2}>
          <Typography variant="h3" textAlign="center">
            You haven&apos;t created any training projects yet
          </Typography>
          <Typography textAlign="center" color="text.secondary">
            Run reproducible, scalable training jobs with full control over data, code, compute, and
            runtime settings.{' '}
            <Link href={links.basetenDocsTrainingOverview} target="_blank">
              Learn more
            </Link>
          </Typography>
        </Stack>
        {isTrainingEnabled ||
        org.tierName === Levels.Startup ||
        org.tierName === Levels.Business ? (
          <Button href={links.basetenDocsTrainingOverview} target="_blank">
            Train or fine-tune a model
          </Button>
        ) : (
          <Button
            variant="contained"
            color="primary"
            href="https://www.baseten.co/talk-to-us/request-access/"
            target="_blank"
            endIcon={<LockIcon />}
          >
            Request access
          </Button>
        )}
      </Stack>
    </EmptyStateContainer>
  );
}

export { EmptyState };
